import React, { useState, useEffect, useCallback } from 'react';
import { Card, List, Pagination, Spin, ConfigProvider, Empty } from 'antd';
import styles from './ListOfCertifiedEnterprises.module.scss';
import zhCN from 'antd/es/locale/zh_CN';
import { useNavigate } from 'react-router-dom';
import { PostMemberList } from '../../api/memberAttestation/list';

const ListOfCertifiedEnterprises = ({ ListOfCertifiedEnterprisesdata }) => {
  const navigate = useNavigate(); // 初始化 useNavigate
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10); // 默认每页条数

  const getResponseData = useCallback(async (pageIndex, pageSize) => {
    if (loading) return; // 避免重复请求
    setLoading(true); // 开始加载数据
    try {
      const { data: response } = await PostMemberList({
        pageIndex, // 使用传入的页码
        pageSize,  // 使用传入的每页数量
        status: 1,
        keyword: ''
      });
      setData(response.data); // 更新数据
      setTotal(response.totalCount); // 更新总数
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // 完成加载
    }
  }, [loading]);

  useEffect(() => {
    getResponseData(currentPage, pageSize); // 页面加载时获取数据
  }, [currentPage, pageSize]); // 当页码或每页数量发生变化时重新获取数据

  const handlePageChange = (page) => {
    setCurrentPage(page); // 设置当前页码
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size); // 更新每页显示条数
    setCurrentPage(1); // 重置为第一页，防止出现分页越界
  };

  const handleItemClick = (item) => {
    const { name, id } = item;
    const queryParams = new URLSearchParams({
      name, id
    });
    navigate(`/home3?${queryParams.toString()}`);
  };

  return (
    <ConfigProvider locale={zhCN}>
      <Spin spinning={loading} size="large" tip="加载中...">
        {!loading && data.length > 0 && (
          <Card className={styles.ListOfCertifiedEnterprises}>
            <div className={styles.Title}>获证企业名录（排名不分先后）</div>
            <List
              itemLayout="horizontal"
              dataSource={data} // 使用全量数据，无需分页切割
              renderItem={(item) => (
                <List.Item onClick={() => handleItemClick(item)} style={{ cursor: 'pointer' }}>
                  <List.Item.Meta
                    title={
                      <div className={styles.listClass}>
                        <div className={styles.customTitle}></div>
                        <div className={styles.listName}>{item.name}</div>
                      </div>}
                  ></List.Item.Meta>
                </List.Item>
              )}
            />
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={total}
              onChange={handlePageChange}
              onShowSizeChange={handlePageSizeChange} // 监听每页条数变化
              showSizeChanger
              // showQuickJumper
              style={{ display: 'flex', justifyContent: 'center' }}
            />
          </Card>
        )}
        {!loading && data.length === 0 && (
          <Empty description="暂无数据" />
        )}
      </Spin>
    </ConfigProvider>
  );
};

export default ListOfCertifiedEnterprises;
